import { createFileRoute } from '@tanstack/react-router';
import { SignInPage } from '@pages/sign-in';

/** Anmeldeseite-Route (/sign-in) */
export const Route = createFileRoute('/sign-in')({
  component: SignInPage,
});
